import * as ActionType from '../sidebar';
export function toggleSidebar(data) {
    return function (dispatch) { return dispatch({ type: ActionType.TOGGLE_SIDEBAR, data: data }); };
}
export function toggleUserMenu(data) {
    return function (dispatch) { return dispatch({ type: ActionType.TOGGLE_USER_MENU, data: data }); };
}
export function setActiveTab(data) {
    return { type: ActionType.SET_ACTIVE_TAB, data: data };
}
export function setCouponModal(data) {
    return function (dispatch) { return dispatch({ type: ActionType.SET_COUPON_MODAL, data: data }); };
}



// WEBPACK FOOTER //
// ./src/actions/creators/sidebar.js